<template>
    <v-card style="max-width: fit-content; padding: 10px; vertical-align: top;" flat color="transparent">
        <h6>CAD図面完了予定日別受信総数※CADのみ表示 <span style="color: red;">【トライアル】</span></h6>
        <v-simple-table dense style="width: 435px;" class="my-custom-table">
            <template v-slot:default>
                <thead>
                    <tr>
                        <td style="border: 1px solid white;background-color: #c5e8f8;position: sticky;z-index: 1;left:0"></td>
                        <td v-for="(date,index) in coveredDates" :key="date" :style="{ backgroundColor: index === 1 ? 'yellow' : (holidays.includes(date) ? 'gray' : '#c5e8f8'), border: '1px solid white'}">{{ formatDate(date) }}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data" :key="item.type">
                        <td style="text-align: center;border: 1px solid white; background-color: #ddeff7;position: sticky;z-index: 1;left:0">{{ item.type }}</td>
                        <td style="text-align: center;border: 1px solid white;" :style="{ backgroundColor : (holidays.includes(date) ? 'gray' : '')}" v-for="(value, date) in item.requestsPerDate" :key="date">{{ value }}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
        <h6 style="color:rgb(248, 92, 92)">※即日CAD依頼の1日の上限は30件となります。</h6>
        <h6 style="color:rgb(248, 92, 92)">※1日の上限数を越えた場合は、翌営業日以降の完了となります。</h6>
        <!-- <h3 class="blink" v-if="tomExpressCount > 0">本日または翌営業日完了予定の即日CAD依頼数が上限となりました。<br> 翌営業日または翌々営業日以降の完了予定となります。</h3> -->
        <h3 class="blink" v-if="totalSameDayRequest > 30">本日または翌営業日完了予定の即日CAD依頼数が上限となりました。<br> 翌営業日または翌々営業日以降の完了予定となります。</h3>
    </v-card>
</template>

<script>
import moment from 'moment';
export default {
    data() {
        return {
            yesterday : moment().subtract(1, 'days').format('YYYY-MM-DD'),
            // yesterday : '2023-11-28',
            coveredDates: [],
            today: moment().format('YYYY-MM-DD'),
            holidays : [],
            data: [],
            tomExpressCount:  0,
            totalSameDayRequest : ""
        };
    },

    mounted() {
        this.getHOlidays().then(() => {
            this.countDays();
            this.getXmlBundleDataPerDueDate()
            // this.getTomorrowExpressCount()
        });

    },

    methods: {
        getHOlidays() {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: '/api/hrdCalendar/index',
                }).then((res) => {
                    this.holidays = res.data.map((item) => {
                        return item.date
                    })
                    this.holidays.sort((a, b) => {
                        return new Date(a) - new Date(b)
                    });
                    resolve();
                }).catch((error) => {
                    reject(error)
                });
            });
        },

        countDays() {
            this.coveredDates.push(this.yesterday)
            let currentDate = new Date(this.yesterday)
            let count = 0

            while (count < 3) {
                currentDate.setDate(currentDate.getDate() + 1)
                let dateString = currentDate.toISOString().split('T')[0]

                if (!this.holidays.includes(dateString)) {
                    this.coveredDates.push(dateString)
                    count++
                } else {
                    this.coveredDates.push(dateString)
                }
            }
        },

        formatDate(dateString) {
            const date = new Date(dateString)
            const day = date.getDate()
            const month = date.getMonth() + 1
            const weekDay = ["日", "月", "火", "水", "木", "金", "土"][date.getDay()]
            return `${month}/${day} (${weekDay})`
        },

        getXmlBundleDataPerDueDate() {
            axios({
                method : 'post',
                url : 'api/xml_bundle_cad_due_date',
                data : { coveredDates : this.coveredDates }
            }).then((res) => {
                this.data = res.data
                this.totalSameDayRequest = res.data[1].requestsPerDate[this.today]
                // this.getTomorrowExpressCount()
                // this.tomExpressCount = Object.entries(res.data[1].requestsPerDate)[2][1]
                // console.log(Object.entries(res.data[1].requestsPerDate)[2][1])
            })
        },

        getTomorrowExpressCount() {
            axios({
                method : 'post',
                url : 'api/xml_bundle_express_tom'
            }).then((r) => {
                this.tomExpressCount = r.data
            })
        }
    }
};
</script>

<style>
.my-custom-table thead tr td {
    height: 25px !important;
}

.my-custom-table tbody tr td {
    height: 25px !important;
}
.blink {
    animation: blinker 2.5s step-end infinite;
    margin-top: 10px;
    color: blue;
}
@keyframes blinker {
    50% {
        opacity: 0.1;
    }
}
</style>
